import gql from 'graphql-tag';

export const checkPropertyNameInCity = variables => ({
  operationName: 'LP_CheckPropertyNameInCity',
  variables,
  query: `
    query LP_CheckPropertyNameInCity($input: CheckPropertyNameInCityInput!) {
			checkPropertyNameInCity(
        input: $input,
			) {
				success
			}
    }`,
});

export const getCityIdByName = variables => ({
  operationName: 'LP_getCityIDByName',
  variables,
  query: `
	query LP_getCityIDByName($nameLike: String) {
		cities(nameLike: $nameLike) {
			edges {
				node {
					slug
					id
					name
          originalName
          country {
            name
            originalName
			      currencyCode
            countryCode
          }
				}
			}
		}
	}
	`,
});

export const MUTATION_CREATE_PROPERTY = gql`
  mutation mutationCreateProperty($input: CreatePropertyInput!) {
    createProperty(input: $input) {
      property {
        id
      }
    }
  }
`;

export const QUERY_GET_CITIES = gql`
  query queryGetCities($nameLike: String, $countrySlugs: [String]) {
    cities(nameLike: $nameLike, countrySlugs: $countrySlugs) {
      edges {
        node {
          id
          name
          slug
        }
      }
    }
  }
`;

export const QUERY_GET_COUNTRIES = gql`
  query queryGetCountries($pageSize: Int) {
    countries(pageSize: $pageSize) {
      edges {
        node {
          id
          name
          slug
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_GALLERY = gql`
  mutation mutationUpdateGallery($input: UpdateGalleryInput!) {
    updateGallery(input: $input) {
      gallery {
        propertyId
      }
    }
  }
`;

export const MUTATION_COMPLETE_ONBOARDING = gql`
  mutation mutationCompleteOnboarding($input: CompleteOnboardingInput!) {
    completeOnboarding(input: $input) {
      landlord {
        id
      }
    }
  }
`;

export const QUERY_FIRST_PROPERTY = gql`
  query queryProperties($pageNumber: Int!, $pageSize: Int!, $isCheckAuth: Boolean) {
    properties(pageNumber: $pageNumber, pageSize: $pageSize, isCheckAuth: $isCheckAuth) {
      totalCount
      edges {
        node {
          id
          name
          propertyType {
            slug
          }
          landlord {
            businessScale
            name
            status
          }
          heroImage {
            path
            source
            hero
            id
          }
        }
      }
    }
  }
`;
